const months = [
  { label: 'Enero', value: 'january' },
  { label: 'Febrero', value: 'february' },
  { label: 'Marzo', value: 'march' },
  { label: 'Abril', value: 'april' },
  { label: 'Mayo', value: 'may' },
  { label: 'Junio', value: 'june' },
  { label: 'Julio', value: 'july' },
  { label: 'Agosto', value: 'august' },
  { label: 'Septiembre', value: 'september' },
  { label: 'Octubre', value: 'october' },
  { label: 'Noviembre', value: 'november' },
  { label: 'Diciembre', value: 'december' }
];

export const monthsNumbers = [
  { label: 'Enero', value: 1 },
  { label: 'Febrero', value: 2 },
  { label: 'Marzo', value: 3 },
  { label: 'Abril', value: 4 },
  { label: 'Mayo', value: 5 },
  { label: 'Junio', value: 6 },
  { label: 'Julio', value: 7 },
  { label: 'Agosto', value: 8 },
  { label: 'Septiembre', value: 9 },
  { label: 'Octubre', value: 10 },
  { label: 'Noviembre', value: 11 },
  { label: 'Diciembre', value: 12 }
];

const years = Array.from(Array(80), (e, i) => ({ label: i + 2000, value: i + 2000 }));

export { years, months };
